import React, {
  useState,
  useContext,
  Component,
  useRef,
  useEffect,
} from "react";
import CartContext from "./CartContext";
import { Link, Navigate } from "react-router-dom";
import { Nav, Table, OverlayTrigger, Tooltip, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { LoadSpinner } from "./LoadSpinner";
import ReactToPrint from "react-to-print";
import axios from "axios";

export default class UserOrders extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      firstLoad: false,
      userOrders: [],
      loadSpinnerOpen: false,
      selectedOrderRow: "",
    };
  }

  OnOrderRowSelect = (e, order) => {
    this.setState({ selectedOrderRow: order });
  };

  ShowLoadSpinner = () => this.setState({ loadSpinnerOpen: true });
  HideLoadSpinner = () => this.setState({ loadSpinnerOpen: false });

  GetUserOrders = async () => {
    try {
      this.ShowLoadSpinner();

      const response = await fetch(
        `${process.env.REACT_APP_API}Consumers/GetUserOrders/${this.context.storeId}/${this.context.userData.id}`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.context.userData.bearertoken}`,
          },
        }
      );

      if (response.status === 401) {
        // Token expired or invalid
        this.HideLoadSpinner();
        alert("Your session has expired. Please log in again.");
        // optionally: this.context.logoutUser();
        return;
      }

      if (response.status === 404) {
        // No orders found
        this.setState({ userOrders: [] });
        this.HideLoadSpinner();
        return;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      this.setState({ userOrders: data });
    } catch (error) {
      console.error("Error loading user orders:", error);
    } finally {
      this.HideLoadSpinner();
    }
  };

  componentDidMount() {
    if (!this.state.firstLoad) {
      this.setState({ firstLoad: true }, () => this.GetUserOrders());
    }
  }

  GetOrderStatus = (orderStatusId) => {
    const list = this.context.orderStatusTypes.filter(
      (e) => e.id === orderStatusId
    );
    return list.length > 0 ? list[0].statusName : "";
  };

  Reload = () => {
    this.setState({ userOrders: [] }, () => this.GetUserOrders());
  };

  OnCancelOrder = (e, order) => {
    const updatedOrder = {
      ...order,
      orderStatus: this.context.OrderStates.CANCELANDCLOSE,
    };

    fetch(process.env.REACT_APP_API + "StoreManager/UpdateOrderStatus/", {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedOrder),
    })
      .then((res) => {
        if (res.status !== 200) throw new Error("Cancel failed");
        this.Reload();
        Swal.fire({
          title: "Status",
          text: "Deleted Successfully",
          timer: 1000,
          showConfirmButton: false,
          icon: "success",
        });
      })
      .catch((error) => {
        this.Reload();
        Swal.fire({
          icon: "error",
          title: "Cancel Failed",
          text: error.message,
        });
      });
  };

  // 🚀 NEW: Reorder logic
  OnReorder = (order) => {
    if (!order?.customerOrderedItems?.length) {
      Swal.fire(
        "No items found!",
        "This order has no items to reorder.",
        "info"
      );
      return;
    }

    let addedCount = 0;
    order.customerOrderedItems.forEach((oi) => {
      const prod = (this.context.prodsAll || []).find(
        (p) => p.id === oi.productId
      );
      if (prod) {
        this.context.addToPOSCart(this.context.selectedPOS, {
          prod,
          qty: oi.qty,
        });
        addedCount++;
      }
    });

    if (addedCount > 0) {
      Swal.fire({
        icon: "success",
        title: "Reorder Successful",
        text: `${addedCount} item(s) added back to cart`,
        timer: 1500,
        showConfirmButton: false,
      });
    } else {
      Swal.fire(
        "Products not found",
        "Could not find matching products for reorder.",
        "warning"
      );
    }
  };

  render() {
    if (this.context.storeId === "") return <Navigate to="/home" />;

    return (
      <>
        {this.state.loadSpinnerOpen && <LoadSpinner open="true" />}
        <div className="Container-fluid mx-0 px-1">
          <div className="row mt-2 mx-1 px-1">
            <div className="col-md-12">
              <h1 className="producttitlefontandsizeDesktop">
                <b>My Orders</b>
              </h1>

              {window.innerWidth > 900 ? (
                // ---------- DESKTOP ----------
                <Table>
                  <tbody>
                    <tr>
                      <td width="60%" className="border bg-light ">
                        <div
                          style={{
                            overflowY: "auto", // ✅ vertical scroll only
                            minHeight: window.innerHeight - 100 + "px",
                            maxHeight: window.innerHeight - 100 + "px",
                          }}
                        >
                          <Table
                            border
                            className="cartviewtable px-5 table-striped"
                            responsive="md"
                            hover
                          >
                            <thead>
                              <tr className="bg-light text-center text-secondary">
                                <th width="25%">Order Placed</th>
                                <th width="10%">Order No</th>
                                <th width="10%">Total Items</th>
                                <th width="10%">Total Amount</th>
                                <th width="20%">Order Status</th>
                                <th width="20%">Delivery Address</th>
                                {/* <th width="10%">Invoice</th> */}
                                <th width="20%">Options</th>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.userOrders
                                .slice()
                                .sort((a, b) =>
                                  new Date(a.orderCreated) <
                                  new Date(b.orderCreated)
                                    ? 1
                                    : -1
                                )
                                .map((p) => (
                                  <tr
                                    key={p.id}
                                    className="text-center text-secondary"
                                    onClick={(e) => this.OnOrderRowSelect(e, p)}
                                  >
                                    <td>
                                      {this.context.GetInDateFormat(
                                        new Date(p.orderCreated)
                                      ) +
                                        " " +
                                        new Date(p.orderCreated).toLocaleString(
                                          "en-US",
                                          {
                                            hour: "numeric",
                                            minute: "numeric",
                                            hour12: true,
                                          }
                                        )}
                                    </td>
                                    <td>
                                      <b>{p.orderId}</b>
                                    </td>
                                    <td>{p.customerOrderedItems.length}</td>
                                    <td>{Math.round(Number(p.totalAmt), 0)}</td>
                                    <td>
                                      <b>
                                        {this.GetOrderStatus(p.orderStatus)}
                                      </b>
                                    </td>
                                    <td>
                                      {
                                        p.customerOrderDeliveryAddresses?.[0]
                                          ?.firstName
                                      }{" "}
                                      {
                                        p.customerOrderDeliveryAddresses?.[0]
                                          ?.lastName
                                      }
                                      , Phone:{" "}
                                      {
                                        p.customerOrderDeliveryAddresses?.[0]
                                          ?.mobileNo
                                      }
                                      ,{" "}
                                      {
                                        p.customerOrderDeliveryAddresses?.[0]
                                          ?.address
                                      }
                                      ,{" "}
                                      {
                                        p.customerOrderDeliveryAddresses?.[0]
                                          ?.city
                                      }
                                      ,{" "}
                                      {
                                        p.customerOrderDeliveryAddresses?.[0]
                                          ?.state
                                      }
                                      ,{" "}
                                      {
                                        p.customerOrderDeliveryAddresses?.[0]
                                          ?.country
                                      }{" "}
                                      -{" "}
                                      {
                                        p.customerOrderDeliveryAddresses?.[0]
                                          ?.pinCode
                                      }
                                    </td>
                                    {/* <td>
                                      <a
                                        href={`${
                                          this.context.store.storageBlobUrl
                                        }${
                                          this.context.store
                                            .storageBlobContainerName
                                        }/invoice/${p.orderId}.html${
                                          this.context.store.storageSasToken
                                        }&ts=${Date.now()}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        download
                                      </a>
                                    </td> */}
                                    <td>
                                      <div className="d-flex gap-2 justify-content-center">
                                        {/* 🚀 Cancel */}
                                        <OverlayTrigger
                                          overlay={
                                            <Tooltip>Cancel Order!</Tooltip>
                                          }
                                        >
                                          <Button
                                            className="mainthemecolor"
                                            disabled={
                                              this.context.storeSettings
                                                ?.hideCancelOrderinPos === true
                                            }
                                            onClick={(e) => {
                                              if (
                                                window.confirm(
                                                  "Warning! Are you sure you want to Cancel this Order?"
                                                )
                                              ) {
                                                this.OnCancelOrder(e, p);
                                              }
                                            }}
                                          >
                                            Cancel
                                          </Button>
                                        </OverlayTrigger>

                                        {/* 🚀 Reorder */}
                                        <OverlayTrigger
                                          overlay={
                                            <Tooltip>Reorder this!</Tooltip>
                                          }
                                        >
                                          <Button
                                            variant="success"
                                            onClick={() => this.OnReorder(p)}
                                          >
                                            Reorder
                                          </Button>
                                        </OverlayTrigger>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </Table>
                        </div>
                      </td>
                      <td
                        width="40%"
                        style={{ backgroundColor: "black", color: "yellow" }}
                      >
                        <div
                          className="fixedTableHightOrder m-0 p-0 ordertablecustom"
                          style={{ height: window.innerHeight - 165 + "px" }}
                        >
                          {this.state.selectedOrderRow && (
                            <div
                              style={{
                                backgroundColor: "black",
                                color: "yellow",
                              }}
                            >
                              <div className="text-center m-0 p-0">
                                <h4>
                                  Order No.&nbsp;
                                  {this.state.selectedOrderRow.orderId}
                                </h4>
                                <PrintMe
                                  orderId={this.state.selectedOrderRow.id}
                                />
                              </div>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              ) : (
                // ---------- MOBILE ----------
                <small>
                  <Table border className="px-0 table-striped">
                    <thead>
                      <tr className="bg-light text-center text-secondary">
                        <th>Order No</th>
                        <th>Total Amount</th>
                        <th>Status</th>
                        <th>Invoice</th>
                        <th>Options</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.userOrders
                        .slice()
                        .sort((a, b) =>
                          new Date(a.orderCreated) < new Date(b.orderCreated)
                            ? 1
                            : -1
                        )
                        .map((p) => (
                          <tr key={p.id} className="text-center text-secondary">
                            <td>
                              <h5>
                                <b>{p.orderId}</b>
                              </h5>
                              {this.context.GetInDateFormat(
                                new Date(p.orderCreated)
                              ) +
                                " " +
                                new Date(p.orderCreated).toLocaleString(
                                  "en-US",
                                  {
                                    hour: "numeric",
                                    minute: "numeric",
                                    hour12: true,
                                  }
                                )}
                            </td>
                            <td>{Math.round(Number(p.totalAmt), 0)}</td>
                            <td>
                              <b>{this.GetOrderStatus(p.orderStatus)}</b>
                            </td>
                            <td>
                              <a
                                href={`${this.context.store.storageBlobUrl}${
                                  this.context.store.storageBlobContainerName
                                }/invoice/${p.orderId}.html${
                                  this.context.store.storageSasToken
                                }&ts=${Date.now()}`}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                download
                              </a>
                            </td>
                            <td>
                              <div className="d-flex flex-column gap-1">
                                <Button
                                  size="sm"
                                  variant="danger"
                                  onClick={(e) => {
                                    if (
                                      window.confirm(
                                        "Warning! Are you sure you want to Cancel this Order?"
                                      )
                                    ) {
                                      this.OnCancelOrder(e, p);
                                    }
                                  }}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  size="sm"
                                  variant="success"
                                  onClick={() => this.OnReorder(p)}
                                >
                                  Reorder
                                </Button>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </small>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}

// ---------- Print ----------
export function PrintMe({ orderId }) {
  const { storeId } = useContext(CartContext);
  const myref = useRef();
  const [htmltext, setHtmltext] = useState("");

  useEffect(() => {
    if (!orderId) return;
    axios
      .get(
        `${process.env.REACT_APP_API}StoreManager/GetInvoiceHtml/${storeId}/${orderId}`
      )
      .then((response) => {
        if (response.status === 200 && response.data?.length > 0) {
          setHtmltext(response.data);
        }
      })
      .catch((error) => console.error("Invoice fetch error", error));
  }, [orderId, storeId]);

  return (
    <>
      <ReactToPrint
        trigger={() => (
          <Button size="lg" variant="danger" className="w-100">
            Print / Download(pdf)
          </Button>
        )}
        content={() => myref.current}
      />
      <div ref={myref} className="w-100 bg-white text-dark">
        <div dangerouslySetInnerHTML={{ __html: htmltext }} />
      </div>
    </>
  );
}
